import React from 'react';
import { useLocalize } from '@saviynt/common';
import { Link } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { msgs } from '../../../../../utilities/messages';

function ViewScheduleLink({ className, setIsScheduleViewOpen, kind }) {
  const localize = useLocalize();

  const LINK_TEXT = localize(msgs.pam.modalPage.page.viewScheduleLink);

  const handleScheduleModal = (event) => {
    event.preventDefault();

    setIsScheduleViewOpen(true);
  };

  const isKindAccordion = kind === 'accordion';

  return (
    <Link
      className={className}
      href='/'
      url='/'
      onClick={(e) => {
        handleScheduleModal(e);
      }}
      text={LINK_TEXT}
      prefixIconKind={isKindAccordion ? 'Calendar' : null}
      suffixIconKind={!isKindAccordion ? 'ChevronRight' : null}
      target='_self'
      shouldStopPropagation
    />
  );
}

ViewScheduleLink.propTypes = {
  className: PropTypes.string,
  setIsScheduleViewOpen: PropTypes.func.isRequired,
  kind: PropTypes.string,
};

ViewScheduleLink.defaultProps = { className: '', kind: 'accordion' };

export default ViewScheduleLink;
